<script setup lang="ts">

defineProps<{
  title?: string;
  partners: { name: string; logo: string }[];
}>()
</script>

<template>
  <div class="partners-section">
    <h2 v-if="title" class="text-center mb-16 text-3xl opacity-50 uppercase tracking-widest">
      {{ title }}
    </h2>
    
    <div class="partners-grid">
      <div v-for="partner in partners" :key="partner.name" class="partner-logo">
        <img :src="partner.logo" :alt="partner.name" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.partners-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  align-items: center;
}

@media (max-width: 768px) {
  .partners-grid {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-top: 40px;
  }
}
</style>


